<template>
  <div>
    <section class="section has-padding-bottom-xl">
      <the-search/>
    </section>

    <section class="section has-padding-top-sm has-padding-bottom-xl">
      <div class="container">
        <h2 class="title is-5 is-uppercase" v-t="'manuals_title'" />
        <product-cards/>
      </div>
    </section>

    <section class="section has-padding-top-lg">
      <div class="container">
        <h2 class="title is-5 is-uppercase" v-t="'questions_title'" />
        <div class="box">
          <top-questions/>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TheSearch from '@/components/TheSearch'
import ProductCards from '@/components/ProductCards'
import TopQuestions from '@/components/TopQuestions'

export default {
  name: 'Home',
  components: {
    TheSearch,
    ProductCards,
    TopQuestions
  },
  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n>
 {
   "en-US": {
     "title": "Homepage",
     "manuals_title": "User Manuals",
     "questions_title": "Frequently Asked Questions"
   },
   "pt-BR": {
     "title": "Página Inicial",
     "manuals_title": "Manuais de Usuário",
     "questions_title": "Dúvidas Frequentes / FAQ"
   }
 }
</i18n>
